import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("el_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const SERVICES = [
  {
    key: "House Shifting",
    title: "House Shifting",
    priceLabel: "₹4,000 – ₹25,000",
    blurb: "Within-city relocation handled by verified crew, custom crates & doorstep unpacking.",
    image: "https://images.pexels.com/photos/4483938/pexels-photo-4483938.jpeg",
  },
  {
    key: "Packers and Movers",
    title: "Packers & Movers",
    priceLabel: "From ₹8,500",
    blurb: "Long-distance moves across India with insured cargo, GPS tracking and dedicated ops manager.",
    image: "https://images.pexels.com/photos/4554242/pexels-photo-4554242.jpeg",
  },
  {
    key: "Car Transportation",
    title: "Car Transportation",
    priceLabel: "₹8,000 – ₹50,000",
    blurb: "Enclosed & open car carriers with real-time tracking and comprehensive transit insurance.",
    image: "https://images.pexels.com/photos/34539243/pexels-photo-34539243.jpeg",
  },
  {
    key: "Bike Transportation",
    title: "Bike Transportation",
    priceLabel: "₹3,500 – ₹9,000",
    blurb: "Custom crates, padded ties, and door-to-door delivery for two-wheelers of any make.",
    image: "https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?auto=format&fit=crop&w=1200&q=70",
  },
  {
    key: "Delicate Sofa Set Packing",
    title: "Delicate Furniture Packing",
    priceLabel: "₹11,000 – ₹18,000",
    blurb: "Bubble-wrap, corrugated corners, dismantling & reassembly of sofas and antique wood.",
    image: "https://images.pexels.com/photos/3616736/pexels-photo-3616736.jpeg",
  },
  {
    key: "Parcel Services",
    title: "Parcel Services",
    priceLabel: "₹1,000 – ₹3,000",
    blurb: "Small parcels, documents & seasonal luggage moved securely with tracking.",
    image: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1200&q=70",
  },
  {
    key: "Heavy Machinery",
    title: "Heavy Machinery Transport",
    priceLabel: "From ₹10,000",
    blurb: "Cranes, hydraulic lifts and licensed drivers for industrial and commercial equipment.",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=70",
  },
];

export const CONTACT = {
  phone: "+91 96182 22500",
  phoneRaw: "+919618222500",
  whatsapp: "919618222500",
  address:
    "1-10-311 Chandra Reddy Building, Chinna Thokatta, New Bowenpally, Hyderabad, Telangana 500011",
  email: "hello@expresslogistics.in",
  hours: "Mon – Sun · 8:00 AM to 9:00 PM",
  rating: 4.7,
  reviews: 226,
  since: 2016,
};
